import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import Button from 'components/common/Button';
import Total from 'containers/OrderAggregators/components/Total';

const FixedArea = ({
  className,
  cost,
  displayQuotation,
  history,
  buttonText,
  disabled
}) => (
  <div className={className}>
    <Total cost={cost} displayQuotation={displayQuotation} history={history} />
    <div className="button-wrapper">
      <Button type="submit" buttonType="A" disabled={disabled}>
        {buttonText}
      </Button>
    </div>
  </div>
);

const commonStyle = css`
  .button-wrapper {
    button {
      margin: 0;

      &:not(:disabled) {
        box-shadow: 0px 0px 16px 4px ${Colors.gray3};
      }
    }
  }
  @media all and (-ms-high-contrast: none) and (min-width:1025px) {
    position: fixed;
    top: auto !important;
    bottom: 30px !important;
    height: 460px;
    width: 308px;
  }
  @media all and (-ms-high-contrast: none) and (max-width:1600px) {
    right: 10px;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  position: sticky;
  top: 175px;
  height: 460px;
  width: 308px;

  &:has(.displayModal) {
    z-index: 999;
  }

  .button-wrapper {
    margin-top: 24px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  display: flex;
  flex-direction: column-reverse;

  .button-wrapper {
    padding: 32px 0;
    border-top: 1px solid ${Colors.gray2};
    margin: 0 16px 76px;
  }
`;

export default applyStyles(FixedArea)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/FixedArea.js